import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  // Title,
  // Tooltip,
  // Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,

);

export const options = {
  responsive: true,
  locale: 'en-US',
  scales: {
    y: {
      min: 0,
      max: 100000,
    }
  },
  plugins: {
    legend: {

    },
    title: {
      display: true,
      text: 'DAO USDT Treasury Changes',
    },
  },
};

const labels = ['July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July'];
export const data = {
  labels,
  datasets: [
    {
      fill: true,
      // lineTension: 0.9,
      label: 'USDT',
      pointRadius: 4,
      pointHoverRadius: 8,
      pointBackgroundColor: "#f06331",
      data: [30509, 33529, 7032, 92523, 82649, 71386, 62212, 59321, 45064, 42318, 77206, 51922, 54527],
      borderColor: '#ca3c0a',
      backgroundColor: (context: ScriptableContext<"line">) => {
        const ctx = context.chart.ctx;
        const gradient = ctx.createLinearGradient(0, 0, 0, 250);
        gradient.addColorStop(0, "#ca3c0a");
        gradient.addColorStop(1, "#ca3c0a2e");
        return gradient;

      },
    },
    // {
    //   fill: true,
    //   label: 'HDN',
    //   data: [12.400, 11.282, 11.282, 11.282, 11.282, 11.282, 11.282],
    //   borderColor: 'rgb(53, 162, 235)',
    //   backgroundColor: (context: ScriptableContext<"line">) => {
    //     const ctx = context.chart.ctx;
    //     const gradient = ctx.createLinearGradient(0, 0, 0, 250);
    //     gradient.addColorStop(0, "#1ba777");
    //     gradient.addColorStop(1, "rgba(64,51,57,0)");
    //     return gradient;

    //   },
    // },
  ],
};




export default function USDTChanges() {
  return (


    <div className='card card-style-2'>
      <div class="card-top d-flex justify-content-between align-items-center">
        <h3 class="card-title">DAO USDT Treasury Changes</h3>
        <div class="card-value">$54,527 USDT</div>
      </div>


      <div className='chart'>
        <Line options={options} data={data} />
      </div>


    </div>
  )
}

